import React from "react";
import "./DataSetView.scss";

type DataSetViewProps = {
  viewTitle: string;
  locationType: {
    value: string;
    isFilterApplied: boolean
  };
  location: {
    value: string;
    isFilterApplied: boolean
  };
  litterType: {
    value: string;
    isFilterApplied: boolean
  };
  timeRange: {
    value: string;
    isFilterApplied: boolean
  };
};

export const DataSetView: React.FC<DataSetViewProps> = ({
  viewTitle,
  locationType,
  location,
  litterType,
  timeRange,
}) => {
  return (
    <div className="data_set_view">
      <h5>{viewTitle}</h5>
      <div className="details_container">
        <p className={`${locationType.isFilterApplied ? "data_set_view_filter_applied" : ""}`}>{locationType.value}</p>
        <div className="vertical_divider"> </div>
        <p className={`${location.isFilterApplied ? "data_set_view_filter_applied" : ""}`}> {location.value} </p>
        <div className="vertical_divider"> </div>
        <p className={`${litterType.isFilterApplied ? "data_set_view_filter_applied" : ""}`}> {litterType.value} </p>
        <div className="vertical_divider"> </div>
        <p className={`${timeRange.isFilterApplied ? "data_set_view_filter_applied" : ""}`}> {timeRange.value} </p>
      </div>
    </div>
  );
};
